import apiClient from '../../../api/apiClient';

/**
 * Fetch contacts with optional search query.
 * @param {Object} params - Search parameters (e.g., { search: "John" }).
 * @returns {Array} - List of contacts.
 */
export const fetchContacts = async ({ search = "" } = {}) => {
  try {
    const response = await apiClient.get("/contacts", {
      params: search ? { search } : {} // Only add search param if provided
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching contacts:", error.response?.data || error.message);
    throw new Error(error.response?.data?.message || "Failed to fetch contacts");
  }
};

/**
 * Create a new contact.
 * @param {Object} contactData - Contact information.
 * @returns {Object} - Created contact.
 */
export const createContact = async (contactData) => {
  try {
    const response = await apiClient.post('/contacts', contactData);
    return response.data;
  } catch (error) {
    console.error("Error creating contact:", error.response?.data || error.message);
    throw new Error(error.response?.data?.message || "Failed to create contact");
  }
};

/**
 * Update an existing contact.
 * @param {number} contactId - Contact ID.
 * @param {Object} contactData - Updated contact information.
 * @returns {Object} - Updated contact.
 */
export const updateContact = async (contactId, contactData) => {
  try {
    const response = await apiClient.put(`/contacts/${contactId}`, contactData);
    return response.data;
  } catch (error) {
    console.error("Error updating contact:", error.response?.data || error.message);
    throw new Error(error.response?.data?.message || "Failed to update contact");
  }
};

/**
 * Delete a contact by ID.
 * @param {number} contactId - Contact ID.
 */
export const deleteContact = async (contactId) => {
  try {
    await apiClient.delete(`/contacts/${contactId}`);
  } catch (error) {
    console.error("Error deleting contact:", error.response?.data || error.message);
    throw new Error(error.response?.data?.message || "Failed to delete contact");
  }
};